import React, { useEffect, useState } from "react";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";
import EmptyState from "../components/EmptyState";
import { Link } from "react-router-dom";

export default function Following() {
  const [videos, setVideos] = useState(null);
  useEffect(() => {
    api.get("/following/feed")
      .then((r) => setVideos(r.data))
      .catch(() => setVideos([]));
  }, []);

  if (videos === null) return <div className="pt-32 min-h-screen" />;

  return (
    <div data-testid="following-page" className="pt-32 pb-24 px-4 sm:px-8 md:px-12 max-w-7xl mx-auto">
      <div className="text-xs uppercase tracking-[0.3em] text-tv-accent font-semibold">Your Feed</div>
      <h1 className="font-display font-black text-5xl text-white tracking-tighter mt-2">Following</h1>
      <p className="text-white/60 mt-2">Latest from the creators you follow.</p>

      {videos.length === 0 ? (
        <div className="mt-12">
          <EmptyState
            title="Nothing here yet"
            message="Follow creators to build your personal feed. New drops from them will appear here."
          >
            <Link to="/" className="bg-tv-accent text-black font-bold px-5 py-2.5 rounded-full">Discover creators</Link>
          </EmptyState>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {videos.map((v) => <VideoCard key={v.id} item={v} fullWidth />)}
        </div>
      )}
    </div>
  );
}
